// ad-slot — 广告位类型常量 + 容量上限 + 中文名映射。
//
// 来源:docs/superpowers/specs/2026-06-29-agent-ads-design.md §容量

/** 各广告位最大展示条数 */
export const AD_CAP = {
  forum_list_icon: 20,
  forum_list_card: 4,
  article_banner: 10,
} as const

/** 广告位类型枚举 */
export type AdSlotType = keyof typeof AD_CAP

/** 广告位中文名 */
export const AD_SLOT_LABEL: Record<AdSlotType, string> = {
  forum_list_icon: '论坛-文章列表小图标广告位',
  forum_list_card: '论坛-文章列表瀑布流卡片广告位',
  article_banner: '文章内容页横幅广告位',
}

/** 各广告位广告语最大字符数(码点) — 0 表示该广告位无广告语 */
export const AD_SLOGAN_MAX = {
  forum_list_icon: 4,
  forum_list_card: 20,
  article_banner: 0,
} as const

/** 所有广告位类型值列表(用于遍历) */
export const AD_SLOT_TYPES: AdSlotType[] = [
  'forum_list_icon',
  'forum_list_card',
  'article_banner',
]
